module.exports = __webpack_public_path__ + "static/media/codewars.53c918c5.svg";